import angular from 'angular';
import ContactController from "./contact.controller";
import ShopFormController from "./shopform.controller";
import CompanyFormController from "./companyform.controller";

let contact = angular
    .module('contact', [])
    .controller('ContactController', ContactController)
    .controller('ShopFormController', ShopFormController)
    .controller('CompanyFormController', CompanyFormController);

export default contact;

